import type { FaireProductEntity } from "../../entity_types/product";

export const p_jw2rxfttft: FaireProductEntity = {
  token: "p_jw2rxfttft",
  type: "product",
  name: "LM-BG-1003 TOTE BAG HOT PINK/WHITE STRIPE",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/cf29c5e1deb2bbb7f0f1d73a2ee81973d577e03096fdf90634d90f2d5cff56b6.png",
  galleryImageUrls: [],
  priceDollars: 15,
  description: "This tote bag features a hot pink and white stripe design by Girlie Girl Originals, offering a stylish accessory for women's use. It pairs southern-inspired, fashion-forward branding with a high-quality finish suited for boutiques and retailers seeking distinctive apparel.",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:11.133Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
